import util from '@bmp-vue/core/api/util'

const controller = 'OperadorFrontEnd'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetAllOperadores: function (dto) {
    return util.Axios.GetAll(controller, dto)
  },
  SendEmailRecuperacaoSenha: function (dto) {
    return util.Axios.Post(controller + '/PostEnviaEmailRecuperarSenha', dto)
  },
  GerarPdf: function (dto) {
    return util.Axios.GetBlob(controller + '/GerarPDF', dto)
  },
  GerarExcel: function (dto) {
    return util.Axios.GetBlob(controller + '/GerarExcel', dto)
  },
  ValidarCriacaoOperadorFrontEnd: function (dto) {
    return util.Axios.Post(controller + '/validar-criacao', dto)
  },
  ListarPorCodigoConta: function (dto) {
    return util.Axios.GetAll(controller + `/conta`, dto)
  }
})
